import { createProductExtensions } from './utils';
export var provisioningPageExtensionsWhitelist = ['provisioningPageOptions'];
export var createProvisioningPageExtensions = function createProvisioningPageExtensions(options) {
  return createProductExtensions(provisioningPageExtensionsWhitelist)({
    provisioningPageOptions: options
  });
};